module.exports = class EcAnswer extends schema.Answer {};
